<template>
  <div class="p-pill" :class="{['color-' + color]: color}">
    <slot>{{ label }}</slot>
    <p-button
      v-if="clearable && !disabled && !readonly"
      :disabled="disabled || readonly"
      dense
      :color="color"
      class="clear"
      @click.stop="$emit('clear')"
    >
      <p-icon>clear</p-icon>
    </p-button>
  </div>
</template>

<script lang="ts" functional>
  import Vue from 'vue';

  export default Vue.extend({
    name: 'PPill',
    props: {
      label: { type: String, default: undefined },
      clearable: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      color: { type: String, default: 'interaction' },
    },
  });
</script>
